import React, { useState, useEffect } from "react";
import SmartTabs from "../../components/SmartTabs"
import Paginator from "../../components/Paginator"
import './TeacherPublications.css'

const TeacherPublications = ({teacher}) => {
    const sub_menus = [
        {
            "slug": "journals",
            "menu_text": "Journals"
        },
        {
            "slug": "conferences",
            "menu_text": "Conferences"
        },
        {
            "slug": "books_chapters",
            "menu_text": "Books"
        },
        {
            "slug": "patents",
            "menu_text": "Patents"
        }
    ]
    
    const author_names = teacher.author_names; //To highlight relevant author name in citations

    const [activeSection, setActiveSection] = useState("journals");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;

    const data = teacher.publications? teacher.publications[activeSection] : null;
    data?.sort((a, b) => b.year - a.year); //Latest publications first

    const totalPages = data?.length? Math.ceil(data.length / itemsPerPage): 0;
    const paginatedData = data?.length? data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage) : null;

    const handleSectionChange = (section) => {
        setActiveSection(section);
        setCurrentPage(1); // Reset page when switching sections
    };

    const partition_author_names = (authors) => {
        if (!author_names) return (<span>{authors}</span>);

        for (let i = 0; i < author_names.length; i++) {
            let n = author_names[i];
            let ind = authors.indexOf(n)
            if ( ind !== -1){
                let left = authors.substring(0, ind);
                let mid = authors.substring(ind, ind + n.length);
                let right = authors.substring(ind + n.length);
                return (<span>{left}<strong>{mid}</strong>{right}</span>)
            }
        }
    }

    const showing_n = () => {
        if (!paginatedData) return "";
        let start = (currentPage - 1) * itemsPerPage + 1;
        let end =  currentPage * itemsPerPage;
        if (end > data.length) end = data.length;
        return "Showing item " + start + " to " + end + " (Total " + data.length + ")";
    }

    /* Necessary for Smart Tab Appearance */
    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);  
    useEffect(() => {
        const handleResize = () => {
            setViewportWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    let smart_tabs_placement = "right";
    let smart_tabs_alignment = "left";
    if(viewportWidth < 600){ //break-point
        smart_tabs_placement = "top";
        smart_tabs_alignment = "center";
    }

    return (
        <div className="teacher-publications smart-tabs col-gap-default">
            <div className="tabs">
                <SmartTabs menus={sub_menus} activeMenu={activeSection} setActiveMenu={handleSectionChange} placement={smart_tabs_placement} alignment={smart_tabs_alignment} spacing=".5em"/>              
            </div>

            <div className="tab-data publication-list pub-list-style-2">                
                {
                    activeSection === "journals" && (
                        paginatedData?.map((a, index) => (
                            <div key={a.id || index} className="teacher-data-item">
                                
                                {/* Show year header if this journal's year is different from the previous journal */}
                                {index === 0 || a.year !== paginatedData[index - 1].year ? (
                                    <div className="pub-list-spacer"></div>
                                ) : null}
                                {index === 0 || a.year !== paginatedData[index - 1].year ? (
                                    <h3 className="pub-year-header">{a.year}</h3>
                                ) : null}
                                
                                <div className="journal-pub">
                                    <p>
                                        {partition_author_names(a.authors)},&nbsp;
                                        <span className="jpub-title"><i>"{a.title}",&nbsp;</i></span>
                                        <span className="jpub-journal">{a.journal}
                                        {a.journal_if && <span className="jpub-if">IF : {a.journal_if}</span>},&nbsp;</span>
                                        {a.publisher && (<span>{a.publisher},&nbsp;</span>)}
                                        <span >{a.vol_issue_pp}</span>,&nbsp;
                                        <span >{a.month}</span>&nbsp;
                                        <span >{a.year},&nbsp;</span>
                                        {a.doi && (<span className="jpub-doi">DOI: {a.doi}</span>)}
                                    </p>
                                    { a.available_at && (
                                    <p className="jpub-available-at">
                                        <span className="jpub-available-at-header">Availabe at:</span>
                                        <a className="jpub-available-at-link wrap-word" href={a.available_at}>{a.available_at}</a>
                                    </p>
                                    )}
                                    
                                </div>
                            </div>
                        ))
                    )
                }     
                {
                    activeSection === "conferences" && (
                        paginatedData?.map((a, index) => (
                            <div key={a.id || index} className="teacher-data-item">      
                                {index === 0 || a.year !== paginatedData[index - 1].year ? (
                                    <div className="pub-list-spacer"></div>
                                ) : null}
                                {index === 0 || a.year !== paginatedData[index - 1].year ? (
                                    <h3 className="pub-year-header">{a.year}</h3>
                                ) : null}
                                
                                <div className="journal-pub">
                                    <p>
                                        {partition_author_names(a.authors)},&nbsp;
                                        <span><i>"{a.title}",&nbsp;</i></span>
                                        <span>{a.conference_name},&nbsp;</span>
                                        <span >{a.location}</span>,&nbsp;
                                        {a.publisher && (<span>{a.publisher},&nbsp;</span>)}                                        
                                        <span >{a.month}</span>&nbsp;
                                        <span >{a.year},&nbsp;</span>
                                        {a.doi && (<span className="jpub-doi">DOI: {a.doi}</span>)}
                                    </p>
                                    { a.available_at && (
                                    <p className="jpub-available-at">
                                        <span className="jpub-available-at-header">Availabe at:</span>
                                        <a className="jpub-available-at-link wrap-word" href={a.available_at}>{a.available_at}</a>
                                    </p>
                                    )}
                                    
                                </div>
                            </div>
                        ))
                    )
                }  
                { 
                    totalPages > 1 && 
                    <div className="paginator-container" style={{marginTop: '30px'}}>
                        <p style={{fontSize: '.9em', fontWeight: 300}}>{showing_n()}</p>                                  
                        <Paginator 
                            currentPage={currentPage} 
                            totalPages={totalPages} 
                            onPageChange={setCurrentPage} 
                        />
                    </div>   
                }
                        
                
            </div>
        </div>
    );
};

export default TeacherPublications;